import { render } from "./Id.vue?vue&type=template&id=3d685724&scoped=true"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"

import "./Id.vue?vue&type=style&index=0&id=3d685724&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d685724"]])

export default __exports__